import { render } from "./comparison-grid-small.vue?vue&type=template&id=4acfadf6"
import script from "./comparison-grid-small.vue?vue&type=script&lang=js"
export * from "./comparison-grid-small.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__